import React from 'react';

import AffiliateProgramPage from '@/features/affiliate-program/pages/affiliate-program.page';

const AffiliateProgramRoute = () => {
  return <AffiliateProgramPage />;
};

export default AffiliateProgramRoute;
